module.exports = __webpack_public_path__ + "static/media/wizualizacja-41.fda2ee16.png";